import * as Notifications from "expo-notifications";
import * as Device from "expo-device";
import Constants from "expo-constants";
import { Platform } from "react-native";

export async function registerForPushNotificationsAsync() {
    console.log("Registering for push notifications");
    if (Platform.OS === "android") {
        await Notifications.setNotificationChannelAsync("default", {
            name: "default",
            importance: Notifications.AndroidImportance.MAX,
            vibrationPattern: [0, 250, 250, 250],
            lightColor: "#FF231F7C",
        });
    }

    if (Platform.OS === "web") {
        return null;
    }

    if (Device.isDevice) {
        const { status: existingStatus } =
            await Notifications.getPermissionsAsync();
        let finalStatus = existingStatus;
        if (existingStatus !== "granted") {
            const { status } = await Notifications.requestPermissionsAsync();
            finalStatus = status;
        }
        if (finalStatus !== "granted") {
            throw new Error(
                "Permission not granted to get push token for push notification!"
            );
        }
        const projectId =
            Constants?.expoConfig?.extra?.eas?.projectId ??
            Constants?.easConfig?.projectId;
        if (!projectId) {
            throw new Error("Project ID not found");
        }
        try {
            const expoPushToken = (
                await Notifications.getExpoPushTokenAsync({
                    projectId,
                })
            ).data;
            console.log("Expo Push Token:", expoPushToken);

            let deviceToken = null;
            if (Platform.OS === 'android') {
                deviceToken = (await Notifications.getDevicePushTokenAsync()).data;
            } else if (Platform.OS === 'ios') {
                deviceToken = (await Notifications.getDevicePushTokenAsync()).data;
            }
            console.log("Device Push Token:", deviceToken);

            return { expoPushToken, deviceToken };
        } catch (e: unknown) {
            throw new Error(`${e}`);
        }
    } else {
        throw new Error("Must use physical device for push notifications");
    }
}